module.exports = require('./helpers/bundle-url').getBundleURL('kSbYx') + "logo.c51670a8.svg";